module.exports = __webpack_public_path__ + "static/media/star.1ea694d9.svg";